export enum AxisTypeEnum {
    X = 1,
    Y = 2
}

export class AxisType {
    public static getByValue(value: number) {
        switch(value) {
            case 1:
                return AxisTypeEnum.X;
            case 2:
                return AxisTypeEnum.Y;
            default:
                return AxisTypeEnum.X;
        }
    }
}